const loader = document.getElementById('loader');

export const toggleLoader = () => {
  loader.classList.toggle('loader--hidden');
};
